export const IMAGE_RESIZE_QUALITY_COMMON = 80;
export const IMAGE_RESIZE_QUALITY_BEST = 95;
